import axiosInstance from 'services/base/axiosInstance';
import { RequestOptionsInterface } from 'model/services/requestOption';
import webStorageClient from 'utils/webStorageClient';
import { message } from 'antd';
import i18n from 'services/i18n';

const deleteRequest = (
  url: string,
  options?: RequestOptionsInterface
): Promise<object> => {
  const data = options?.data;
  const tokenClient = webStorageClient.getToken();
  const enableFlashMessageSuccess = options?.enableFlashMessageSuccess || false;
  const enableFlashMessageError = options?.enableFlashMessageError || true;
  const messageSuccessCustom = options?.messageSuccessCustom || 'success';

  return axiosInstance
    .delete(url, {
      params: options?.params,
      data,
      headers: {
        Authorization: `Bearer ${tokenClient}`
      }
    })
    .then((res: any) => {
      if (enableFlashMessageSuccess) {
        if (res?.message) {
          message.success(i18n?.t(`message:${res?.message}`));
        } else {
          message.success(i18n?.t(`message:${messageSuccessCustom}`));
        }
      }
      return res;
    })
    .catch(err => {
      if (enableFlashMessageError) {
        if (err?.response?.data?.errors?.length > 0) {
          err?.response?.data?.errors?.forEach((mess: string) => {
            message.error(i18n?.t(`message:${mess}`));
          });
        } else if (err?.response?.data?.detail) {
          message.error(err.response.data.detail);
        } else if (err?.response?.data?.message) {
          message.error(err.response.data.message);
        }
      }
      return Promise.reject(err);
    });
};

export { deleteRequest };
